import get from 'transmute/get';
export const getPageId = get('pageId');
export const getInvalidAt = get('invalidAt');
export const getInboxId = get('inboxId');
export const getPageName = get('pageName');
export const getRequiresReAuth = messengerConnection => getInvalidAt(messengerConnection) !== 0;